/* King Kirana Mart — product image copy deterrence.
   Deliberately does NOT intercept click, pointer, touch, swipe or keyboard events. */
(() => {
  'use strict';

  const PRODUCT_IMAGE_SELECTOR = [
    'a[href*="/products/"] img',
    'media-gallery img',
    '[id^="MediaGallery-"] img',
    '.product__media img',
    '.product__media-item img',
    '.product-media-container img',
    '.product__modal-opener img',
    '.product-media-modal img',
    '.quick-shop img',
    '.quick-view img',
    '.quick-add-modal img'
  ].join(',');

  const getProtectedMediaTarget = (target) => {
    if (!(target instanceof Element)) return null;

    const image = target.closest('img');
    if (image && image.matches(PRODUCT_IMAGE_SELECTOR)) return image;

    // Product lightbox (PhotoSwipe) renders its image outside media-gallery.
    const photoSwipeImage = target.closest('.pswp__img');
    if (photoSwipeImage && photoSwipeImage.closest('.pswp')) return photoSwipeImage;

    // The product-page zoom/toggle layer can sit above the actual <img>,
    // so a right-click may land on the overlay/button instead of the image.
    const productMediaOpener = target.closest('modal-opener.product__modal-opener--image');
    if (productMediaOpener && productMediaOpener.closest('media-gallery')) return productMediaOpener;

    const hoverZoomOverlay = target.closest('.image-magnify-full-size');
    if (
      hoverZoomOverlay &&
      hoverZoomOverlay.closest('product-info[data-zoom-on-hover]') &&
      hoverZoomOverlay.closest('.product__media')
    ) {
      return hoverZoomOverlay;
    }

    return null;
  };

  document.addEventListener('contextmenu', (event) => {
    if (getProtectedMediaTarget(event.target)) event.preventDefault();
  }, true);

  document.addEventListener('dragstart', (event) => {
    if (getProtectedMediaTarget(event.target)) event.preventDefault();
  }, true);
})();
